/* import __COLOCATED_TEMPLATE__ from './market-date-select.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
let MarketDateSelect = (_class = class MarketDateSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "localeTime", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "marketDropdown", _descriptor3, this);
  }
  get selectionType() {
    return this.args.selectionType || 'single';
  }
  get startDateString() {
    const d = this.args.startDate;
    return d ? d.toISOString() : null;
  }
  get endDateString() {
    const d = this.args.endDate;
    return d && this.selectionType === 'range' ? d.toISOString() : null;
  }
  get displayDate() {
    const {
      startDate,
      endDate
    } = this.args;
    if (!startDate) {
      return '';
    }
    const formattedStartDate = this.intl.formatDate(startDate);
    if (!endDate || this.selectionType === 'single') {
      return formattedStartDate;
    }
    const formattedEndDate = this.intl.formatDate(new Date(endDate));
    return this.intl.t('sharedUi.dateSelect.rangeFormat', {
      start: formattedStartDate,
      end: formattedEndDate
    });
  }

  // Store market-dropdown element, so we can manually close it when needed.
  marketDropdownInserted(marketDropdown) {
    this.marketDropdown = marketDropdown;
  }
  marketDateRangeChanged(event) {
    this.dismissIfNeeded(event.detail.endDate);
    const startDateString = event.detail.startDate;
    const endDateString = event.detail.endDate;
    const startDate = startDateString ? new Date(startDateString) : null;
    const endDate = endDateString ? new Date(endDateString) : null;
    this.args.onChange(startDate, endDate);
  }
  dismissIfNeeded(endDate) {
    if (!this.args.dismissOnSelection) {
      return;
    }
    if (this.selectionType === 'range' && !endDate) {
      return;
    }
    this.marketDropdown?.closeDropdown();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketDropdown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "marketDropdownInserted", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDropdownInserted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "marketDateRangeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDateRangeChanged"), _class.prototype)), _class);
export { MarketDateSelect as default };